import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { Role } from '../../shared/constants/enums'
import { AuthService } from '../services/auth.service'
import { ToastService } from '../services/toast.service'

@Injectable({ providedIn: 'root' })
export class HasRoleGuard {
    constructor(
        private authService: AuthService,
        private toastService: ToastService
    ) {}

    canActivateChild(activatedRouteChild: ActivatedRouteSnapshot): boolean {
        const userRole = this.authService.getRepresentativeRole()
        const hasAllowedRole = activatedRouteChild.data.allowedRoles.some(
            (allowedRoute: Role) => allowedRoute === userRole
        )
        if (!hasAllowedRole) {
            this.toastService.showWarning('roleGuard.role.notAllowed')
            return false
        }
        return true
    }
}
